import { nestApiClient } from './api-client';
import { CalendarEventsResponse } from '@wwe-portal/entities/calendar.type';

export const getCalendarEvents = async (params: {
  startDateFrom: number;
  startDateTo: number;
  endDateFrom: number;
  endDateTo: number;
}) => {
  return nestApiClient.get<CalendarEventsResponse>('/api/v1/events', {
    params,
  });
};
